<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 *  dashboard component
 */
export default {
  page: {
    title: "Product Performance",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    ModelListSelect,
    // apexchart: VueApexCharts,
  },
  data() {
    return {
      test:[],
      chartselect: {
        data: 'bar',
      },
      productdata: '',
      load_status: true,
      items: [
        {
          text: "Product Performance",
          href: "/",
        },
        {
          text: "Product Performance",
          active: true,
        },
      ],

      timeFilters: [
        // { title: "Customise", value: "custom" },     
        { title: "All", value: "all" },
        { title: "Last 7 days", value: "last7D" },
        { title: "Last 4 Weeks", value: "last4W" },
        { title: "Last 8 Weeks", value: "last8W" },
        { title: "Last 3 Months", value: "last3M" },
        { title: "Last 6 Months", value: "last6M" },
      ],
      filterData: {
        time: "all",
        dateRange: "",
        product: 'all',
      },
      graphLabel: "for all time",

      daysOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],

      // GRAPH DATA     
      // SERVICE ANALYSIS GRAPH BAR CHART
      columnChart: {
        series: [
          {
            name: "Data",
            data: [0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Product Performance analysis',
                },
                png: {
                  filename: 'Product Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: false,
              columnWidth: "100%",
            },
          },
          dataLabels: {
            enabled: false,
          },          
            stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#002AFF","#e9f029","#FF0000","#EB8C87","#29f040","#C23829","#18f0e1","#c50ff2","#f20f88","","#556ee6","#29f040","#C23829"],
          xaxis: {
            categories: this.Products??[],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
        },
      },
      ProductcolumnChart: {
        series: [
          {
            name: "Data",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-Product Performance analysis',
                },
                png: {
                  filename: 'Per-Product Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: false,
              columnWidth: "100%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#002AFF","#e9f029","#FF0000","#EB8C87","#29f040","#C23829","#18f0e1","#c50ff2","#f20f88","","#556ee6","#29f040","#C23829"],
          xaxis: {
            categories: ['', '', '', '', '', '', '', '','', '','', ''],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
        },
      },
      ProductdonutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: ['', '', '', '', '', '', '', '','', '','', ''],
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-Product Performance analysis',
                },
                png: {
                  filename: 'Per-Product Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
            grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
          },
        },
      },
      donutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: this.Products??[],
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Product Performance analysis',
                },
                png: {
                  filename: 'Product Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
        },
      },
      LineChart: {
        series: [
          {
            name: "Income",
            data: [0],
          }
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Product Performance analysis',
                },
                png: {
                  filename: 'Product Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "..",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      ProductLineChart: {
        series: [
          {
            name: "Data",
            data: [0],
          }
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-Product Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-Product Performance analysis',
                },
                png: {
                  filename: 'Per-Product Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "..",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      Labels:{
        label1: '',
        label2: '',
        label3: '',
        label4: '',
        label5: '',
        label6: '',
        label7: '',
        label8: '',
        label9: '',
        label10: '',
        label11: '',
        label12: '',
      }
    };
  },  
  methods: {
    ...mapActions({
      FetchGraph: "visualisation/fetchProductPerformance",
      FetchProducts: "products/fetchProducts",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    setProductLabel() {
      if (this.filterData.time == "today") {
        this.graphLabel = "today";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last7D") {
        this.graphLabel = "in last 7 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last4W") {
        this.graphLabel = "in last 4 Weeks";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last8W") {
        this.graphLabel = "in last 8 Weeks";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last3M") {
        this.graphLabel = "in last 3 Month";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last6M") {
        this.graphLabel = "in last 6 Months";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "all") {
        this.graphLabel = "for all time";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "custom") {
        this.graphLabel = "";
        this.filterData.dateRange = "";
      }

      this.Products.filter((item)=>{
          if(this.filterData.product == item.id){
              this.productdata = item.name
          }            
      });
    },

    //Per user graphs    
    ProductCheck(){
        this.FetchGraph(this.filterData); 
    }
  },

  computed: {
    ...mapState("visualisation", ["product_performance"]),
    ...mapGetters("visualisation", ["ProductPerformance"]),
    ...mapGetters("auth", ["MyUserPerm","User"]),
    ...mapGetters("products", ["Products"]),
  },

  watch: {
    ProductPerformance(newValue) {
      if (newValue) {
        this.ProductcolumnChart.series[0].data[0] = 0;
        this.ProductcolumnChart.series[0].data[1] = 0;
        this.ProductcolumnChart.series[0].data[2] = 0;
        this.ProductcolumnChart.series[0].data[3] = 0;
        this.ProductcolumnChart.series[0].data[4] = 0;
        this.ProductcolumnChart.series[0].data[5] = 0;
        this.ProductcolumnChart.series[0].data[6] = 0;
        this.ProductcolumnChart.series[0].data[7] = 0;
        this.ProductcolumnChart.series[0].data[8] = 0;
        this.ProductcolumnChart.series[0].data[9] = 0;
        this.ProductcolumnChart.series[0].data[10] = 0;
        this.ProductcolumnChart.series[0].data[11] = 0;
        if(this.filterData.product == 'all'){
          //User Column Chart
          this.ProductPerformance[0]?(this.columnChart.series[0].data[0] = parseInt(this.ProductPerformance[0].total_sales)):0;
          this.ProductPerformance[1]?(this.columnChart.series[0].data[1] = parseInt(this.ProductPerformance[1].total_sales)):0;
          this.ProductPerformance[2]?(this.columnChart.series[0].data[2] = parseInt(this.ProductPerformance[2].total_sales)):0;
          this.ProductPerformance[3]?(this.columnChart.series[0].data[3] = parseInt(this.ProductPerformance[3].total_sales)):0;
          this.ProductPerformance[4]?(this.columnChart.series[0].data[4] = parseInt(this.ProductPerformance[4].total_sales)):0;
          this.ProductPerformance[5]?(this.columnChart.series[0].data[5] = parseInt(this.ProductPerformance[5].total_sales)):0;
          this.ProductPerformance[6]?(this.columnChart.series[0].data[6] = parseInt(this.ProductPerformance[6].total_sales)):0;
          this.ProductPerformance[7]?(this.columnChart.series[0].data[7] = parseInt(this.ProductPerformance[7].total_sales)):0;
          this.ProductPerformance[8]?(this.columnChart.series[0].data[8] = parseInt(this.ProductPerformance[8].total_sales)):0;
          this.ProductPerformance[9]?(this.columnChart.series[0].data[9] = parseInt(this.ProductPerformance[9].total_sales)):0;
          this.ProductPerformance[10]?(this.columnChart.series[0].data[10] = parseInt(this.ProductPerformance[10].total_sales)):0;
          this.ProductPerformance[11]?(this.columnChart.series[0].data[11] = parseInt(this.ProductPerformance[11].total_sales)):0;

          this.ProductPerformance[0]?(this.columnChart.chartOptions.xaxis.categories[0] = this.ProductPerformance[0].product_name):'';
          this.ProductPerformance[1]?(this.columnChart.chartOptions.xaxis.categories[1] = this.ProductPerformance[1].product_name):'';
          this.ProductPerformance[2]?(this.columnChart.chartOptions.xaxis.categories[2] = this.ProductPerformance[2].product_name):'';
          this.ProductPerformance[3]?(this.columnChart.chartOptions.xaxis.categories[3] = this.ProductPerformance[3].product_name):'';
          this.ProductPerformance[4]?(this.columnChart.chartOptions.xaxis.categories[4] = this.ProductPerformance[4].product_name):'';
          this.ProductPerformance[5]?(this.columnChart.chartOptions.xaxis.categories[5] = this.ProductPerformance[5].product_name):'';
          this.ProductPerformance[6]?(this.columnChart.chartOptions.xaxis.categories[6] = this.ProductPerformance[6].product_name):'';
          this.ProductPerformance[7]?(this.columnChart.chartOptions.xaxis.categories[7] = this.ProductPerformance[7].product_name):'';
          this.ProductPerformance[8]?(this.columnChart.chartOptions.xaxis.categories[8] = this.ProductPerformance[8].product_name):'';
          this.ProductPerformance[9]?(this.columnChart.chartOptions.xaxis.categories[9] = this.ProductPerformance[9].product_name):'';
          this.ProductPerformance[10]?(this.columnChart.chartOptions.xaxis.categories[10] = this.ProductPerformance[10].product_name):'';
          this.ProductPerformance[11]?(this.columnChart.chartOptions.xaxis.categories[11] = this.ProductPerformance[11].product_name):'';
          
          
          
          //User Line Chart
          this.ProductPerformance[0]?(this.LineChart.series[0].data[0] = parseInt(this.ProductPerformance[0].total_sales)):0;
          this.ProductPerformance[1]?(this.LineChart.series[0].data[1] = parseInt(this.ProductPerformance[1].total_sales)):0;
          this.ProductPerformance[2]?(this.LineChart.series[0].data[2] = parseInt(this.ProductPerformance[2].total_sales)):0;
          this.ProductPerformance[3]?(this.LineChart.series[0].data[3] = parseInt(this.ProductPerformance[3].total_sales)):0;
          this.ProductPerformance[4]?(this.LineChart.series[0].data[4] = parseInt(this.ProductPerformance[4].total_sales)):0;
          this.ProductPerformance[5]?(this.LineChart.series[0].data[5] = parseInt(this.ProductPerformance[5].total_sales)):0;
          this.ProductPerformance[6]?(this.LineChart.series[0].data[6] = parseInt(this.ProductPerformance[6].total_sales)):0;
          this.ProductPerformance[7]?(this.LineChart.series[0].data[7] = parseInt(this.ProductPerformance[7].total_sales)):0;
          this.ProductPerformance[8]?(this.LineChart.series[0].data[8] = parseInt(this.ProductPerformance[8].total_sales)):0;
          this.ProductPerformance[9]?(this.LineChart.series[0].data[9] = parseInt(this.ProductPerformance[9].total_sales)):0;
          this.ProductPerformance[10]?(this.LineChart.series[0].data[10] = parseInt(this.ProductPerformance[10].total_sales)):0;
          this.ProductPerformance[11]?(this.LineChart.series[0].data[11] = parseInt(this.ProductPerformance[11].total_sales)):0;

          this.ProductPerformance[0]?(this.LineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[0].product_name):'';
          this.ProductPerformance[1]?(this.LineChart.chartoptions.xaxis.categories[1] = this.ProductPerformance[1].product_name):'';
          this.ProductPerformance[2]?(this.LineChart.chartoptions.xaxis.categories[2] = this.ProductPerformance[2].product_name):'';
          this.ProductPerformance[3]?(this.LineChart.chartoptions.xaxis.categories[3] = this.ProductPerformance[3].product_name):'';
          this.ProductPerformance[4]?(this.LineChart.chartoptions.xaxis.categories[4] = this.ProductPerformance[4].product_name):'';
          this.ProductPerformance[5]?(this.LineChart.chartoptions.xaxis.categories[5] = this.ProductPerformance[5].product_name):'';
          this.ProductPerformance[6]?(this.LineChart.chartoptions.xaxis.categories[6] = this.ProductPerformance[6].product_name):'';
          this.ProductPerformance[7]?(this.LineChart.chartoptions.xaxis.categories[7] = this.ProductPerformance[7].product_name):'';
          this.ProductPerformance[8]?(this.LineChart.chartoptions.xaxis.categories[8] = this.ProductPerformance[8].product_name):'';
          this.ProductPerformance[9]?(this.LineChart.chartoptions.xaxis.categories[9] = this.ProductPerformance[9].product_name):'';
          this.ProductPerformance[10]?(this.LineChart.chartoptions.xaxis.categories[10] = this.ProductPerformance[10].product_name):'';
          this.ProductPerformance[11]?(this.LineChart.chartoptions.xaxis.categories[11] = this.ProductPerformance[11].product_name):'';
          
          //User Donut Chart
          this.donutChart.series[0] = parseInt(this.ProductPerformance[0]?this.ProductPerformance[0].total_sales:0);
          this.donutChart.series[1] = parseInt(this.ProductPerformance[1]?this.ProductPerformance[1].total_sales:0);
          this.donutChart.series[2] = parseInt(this.ProductPerformance[2]?this.ProductPerformance[2].total_sales:0);
          this.donutChart.series[3] = parseInt(this.ProductPerformance[3]?this.ProductPerformance[3].total_sales:0);
          this.donutChart.series[4] = parseInt(this.ProductPerformance[4]?this.ProductPerformance[4].total_sales:0);
          this.donutChart.series[5] = parseInt(this.ProductPerformance[5]?this.ProductPerformance[5].total_sales:0);
          this.donutChart.series[6] = parseInt(this.ProductPerformance[6]?this.ProductPerformance[6].total_sales:0);
          this.donutChart.series[7] = parseInt(this.ProductPerformance[7]?this.ProductPerformance[7].total_sales:0);
          this.donutChart.series[8] = parseInt(this.ProductPerformance[8]?this.ProductPerformance[8].total_sales:0);
          this.donutChart.series[9] = parseInt(this.ProductPerformance[9]?this.ProductPerformance[9].total_sales:0);
          this.donutChart.series[10] = parseInt(this.ProductPerformance[10]?this.ProductPerformance[10].total_sales:0);
          this.donutChart.series[11] = parseInt(this.ProductPerformance[11]?this.ProductPerformance[11].total_sales:0);

          this.donutChart.chartOptions.labels[0] = this.ProductPerformance[0]?this.ProductPerformance[0].product_name:'';
          this.donutChart.chartOptions.labels[1] = this.ProductPerformance[1]?this.ProductPerformance[1].product_name:'';
          this.donutChart.chartOptions.labels[2] = this.ProductPerformance[2]?this.ProductPerformance[2].product_name:'';
          this.donutChart.chartOptions.labels[3] = this.ProductPerformance[3]?this.ProductPerformance[3].product_name:'';
          this.donutChart.chartOptions.labels[4] = this.ProductPerformance[4]?this.ProductPerformance[4].product_name:'';
          this.donutChart.chartOptions.labels[5] = this.ProductPerformance[5]?this.ProductPerformance[5].product_name:'';
          this.donutChart.chartOptions.labels[6] = this.ProductPerformance[6]?this.ProductPerformance[6].product_name:'';
          this.donutChart.chartOptions.labels[7] = this.ProductPerformance[7]?this.ProductPerformance[7].product_name:'';
          this.donutChart.chartOptions.labels[8] = this.ProductPerformance[8]?this.ProductPerformance[8].product_name:'';
          this.donutChart.chartOptions.labels[9] = this.ProductPerformance[9]?this.ProductPerformance[9].product_name:'';
          this.donutChart.chartOptions.labels[10] = this.ProductPerformance[10]?this.ProductPerformance[10].product_name:'';
          this.donutChart.chartOptions.labels[11] = this.ProductPerformance[11]?this.ProductPerformance[11].product_name:'';
        }else{          
          if(this.filterData.time == 'all'){            
            for (const item of this.ProductPerformance) {
              if (item.dataLabel === 1) {
                  this.ProductcolumnChart.series[0].data[0] = item.total_sales;
                  this.ProductLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === 2) {
                  this.ProductcolumnChart.series[0].data[1] = item.total_sales;
                  this.ProductLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === 3) {
                  this.ProductcolumnChart.series[0].data[2] = item.total_sales;
                  this.ProductLineChart.series[0].data[2] = item.total_sales;
              }else if (item.dataLabel === 4) {
                  this.ProductcolumnChart.series[0].data[3] = item.total_sales;
                  this.ProductLineChart.series[0].data[3] = item.total_sales;
              }else if (item.dataLabel === 5) {
                  this.ProductcolumnChart.series[0].data[4] = item.total_sales;
                  this.ProductLineChart.series[0].data[4] = item.total_sales;
              }else if (item.dataLabel === 6) {
                  this.ProductcolumnChart.series[0].data[5] = item.total_sales;
                  this.ProductLineChart.series[0].data[5] = item.total_sales;
              }else if (item.dataLabel === 7) {
                  this.ProductcolumnChart.series[0].data[6] = item.total_sales;
                  this.ProductLineChart.series[0].data[6] = item.total_sales;
              }else if (item.dataLabel === 8) {
                  this.ProductcolumnChart.series[0].data[7] = item.total_sales;
                  this.ProductLineChart.series[0].data[7] = item.total_sales;
              }else if (item.dataLabel === 9) {
                  this.ProductcolumnChart.series[0].data[8] = item.total_sales;
                  this.ProductLineChart.series[0].data[8] = item.total_sales;
              }else if (item.dataLabel === 10) {
                  this.ProductcolumnChart.series[0].data[9] = item.total_sales;
                  this.ProductLineChart.series[0].data[9] = item.total_sales;
              }else if (item.dataLabel === 11) {
                  this.ProductcolumnChart.series[0].data[10] = item.total_sales;
                  this.ProductLineChart.series[0].data[10] = item.total_sales;
              }else if (item.dataLabel === 12) {
                  this.ProductcolumnChart.series[0].data[11] = item.total_sales;
                  this.ProductLineChart.series[0].data[11] = item.total_sales;
              }
            }
            
            this.ProductcolumnChart.chartOptions.xaxis.categories[11] = 'December';
            this.ProductcolumnChart.chartOptions.xaxis.categories[10] = 'November';
            this.ProductcolumnChart.chartOptions.xaxis.categories[9] = 'October';
            this.ProductcolumnChart.chartOptions.xaxis.categories[8] = 'September';
            this.ProductcolumnChart.chartOptions.xaxis.categories[7] = 'August';
            this.ProductcolumnChart.chartOptions.xaxis.categories[6] = 'July';
            this.ProductcolumnChart.chartOptions.xaxis.categories[5] = 'June';
            this.ProductcolumnChart.chartOptions.xaxis.categories[4] = 'May';
            this.ProductcolumnChart.chartOptions.xaxis.categories[3] = 'April';
            this.ProductcolumnChart.chartOptions.xaxis.categories[2] = 'March';
            this.ProductcolumnChart.chartOptions.xaxis.categories[1] = 'February';
            this.ProductcolumnChart.chartOptions.xaxis.categories[0] = 'January';
 
            
            this.ProductLineChart.chartoptions.xaxis.categories[11] = 'December';
            this.ProductLineChart.chartoptions.xaxis.categories[10] = 'November';
            this.ProductLineChart.chartoptions.xaxis.categories[9] = 'October';
            this.ProductLineChart.chartoptions.xaxis.categories[8] = 'September';
            this.ProductLineChart.chartoptions.xaxis.categories[7] = 'August';
            this.ProductLineChart.chartoptions.xaxis.categories[6] = 'July';
            this.ProductLineChart.chartoptions.xaxis.categories[5] = 'June';
            this.ProductLineChart.chartoptions.xaxis.categories[4] = 'May';
            this.ProductLineChart.chartoptions.xaxis.categories[3] = 'April';
            this.ProductLineChart.chartoptions.xaxis.categories[2] = 'March';
            this.ProductLineChart.chartoptions.xaxis.categories[1] = 'February';
            this.ProductLineChart.chartoptions.xaxis.categories[0] = 'January';

            this.ProductdonutChart.chartOptions.labels[11] = 'December';
            this.ProductdonutChart.chartOptions.labels[10] = 'November';
            this.ProductdonutChart.chartOptions.labels[9] = 'October';
            this.ProductdonutChart.chartOptions.labels[8] = 'September';
            this.ProductdonutChart.chartOptions.labels[7] = 'August';
            this.ProductdonutChart.chartOptions.labels[6] = 'July';
            this.ProductdonutChart.chartOptions.labels[5] = 'June';
            this.ProductdonutChart.chartOptions.labels[4] = 'May';
            this.ProductdonutChart.chartOptions.labels[3] = 'April';
            this.ProductdonutChart.chartOptions.labels[2] = 'March';
            this.ProductdonutChart.chartOptions.labels[1] = 'February';
            this.ProductdonutChart.chartOptions.labels[0] = 'January';
          }else if(this.filterData.time == 'last7D'){
            
            //Product Column Chart
            for (const item of this.ProductPerformance) {
              if (item.dataLabel === (new Date().toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[0] = item.total_sales;
                  this.ProductLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[1] = item.total_sales;
                  this.ProductLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[2] = item.total_sales;
                  this.ProductLineChart.series[0].data[2] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[3] = item.total_sales;
                  this.ProductLineChart.series[0].data[3] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[4] = item.total_sales;
                  this.ProductLineChart.series[0].data[4] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[5] = item.total_sales;
                  this.ProductLineChart.series[0].data[5] = item.total_sales;
              }else if (item.dataLabel === (new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0])) {
                  this.ProductcolumnChart.series[0].data[6] = item.total_sales;
                  this.ProductLineChart.series[0].data[6] = item.total_sales;
              }
            }

            this.ProductcolumnChart.chartOptions.xaxis.categories[0] = new Date().toISOString().split('T')[0];        
            this.ProductcolumnChart.chartOptions.xaxis.categories[1] = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];        
            this.ProductcolumnChart.chartOptions.xaxis.categories[2] = new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0];        
            this.ProductcolumnChart.chartOptions.xaxis.categories[3] = new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0];        
            this.ProductcolumnChart.chartOptions.xaxis.categories[4] = new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0];        
            this.ProductcolumnChart.chartOptions.xaxis.categories[5] = new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0];        
            this.ProductcolumnChart.chartOptions.xaxis.categories[6] = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0];       
            this.ProductcolumnChart.chartOptions.xaxis.categories[7] = '';        
            this.ProductcolumnChart.chartOptions.xaxis.categories[8] = '';        
            this.ProductcolumnChart.chartOptions.xaxis.categories[9] = '';        
            this.ProductcolumnChart.chartOptions.xaxis.categories[10] = '';        
            this.ProductcolumnChart.chartOptions.xaxis.categories[11] = ''; 
            
            this.ProductLineChart.chartoptions.xaxis.categories[0] = new Date().toISOString().split('T')[0];        
            this.ProductLineChart.chartoptions.xaxis.categories[1] = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];        
            this.ProductLineChart.chartoptions.xaxis.categories[2] = new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0];        
            this.ProductLineChart.chartoptions.xaxis.categories[3] = new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0];        
            this.ProductLineChart.chartoptions.xaxis.categories[4] = new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0];        
            this.ProductLineChart.chartoptions.xaxis.categories[5] = new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0];        
            this.ProductLineChart.chartoptions.xaxis.categories[6] = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0];       
            this.ProductLineChart.chartoptions.xaxis.categories[7] = '';        
            this.ProductLineChart.chartoptions.xaxis.categories[8] = '';        
            this.ProductLineChart.chartoptions.xaxis.categories[9] = '';        
            this.ProductLineChart.chartoptions.xaxis.categories[10] = '';        
            this.ProductLineChart.chartoptions.xaxis.categories[11] = ''; 
            
            this.ProductdonutChart.chartOptions.labels[0] = new Date().toISOString().split('T')[0];        
            this.ProductdonutChart.chartOptions.labels[1] = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];        
            this.ProductdonutChart.chartOptions.labels[2] = new Date(new Date().setDate(new Date().getDate() - 2)).toISOString().split('T')[0];        
            this.ProductdonutChart.chartOptions.labels[3] = new Date(new Date().setDate(new Date().getDate() - 3)).toISOString().split('T')[0];        
            this.ProductdonutChart.chartOptions.labels[4] = new Date(new Date().setDate(new Date().getDate() - 4)).toISOString().split('T')[0];        
            this.ProductdonutChart.chartOptions.labels[5] = new Date(new Date().setDate(new Date().getDate() - 5)).toISOString().split('T')[0];        
            this.ProductdonutChart.chartOptions.labels[6] = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().split('T')[0];       
            this.ProductdonutChart.chartOptions.labels[7] = '';        
            this.ProductdonutChart.chartOptions.labels[8] = '';        
            this.ProductdonutChart.chartOptions.labels[9] = '';        
            this.ProductdonutChart.chartOptions.labels[10] = '';        
            this.ProductdonutChart.chartOptions.labels[11] = '';
            
          }else if(this.filterData.time == 'last4W'){
              //User Column Chart            
            this.ProductPerformance[0]?(this.ProductcolumnChart.series[0].data[0] = parseInt(this.ProductPerformance[0].total_sales)):this.ProductcolumnChart.series[0].data[0] = 0;
            this.ProductPerformance[1]?(this.ProductcolumnChart.series[0].data[1] = parseInt(this.ProductPerformance[1].total_sales)):this.ProductcolumnChart.series[0].data[1] = 0;
            this.ProductPerformance[2]?(this.ProductcolumnChart.series[0].data[2] = parseInt(this.ProductPerformance[2].total_sales)):this.ProductcolumnChart.series[0].data[2] = 0;
            this.ProductPerformance[3]?(this.ProductcolumnChart.series[0].data[3] = parseInt(this.ProductPerformance[3].total_sales)):this.ProductcolumnChart.series[0].data[3] = 0;
            this.ProductcolumnChart.series[0].data[4] = 0;
            this.ProductcolumnChart.series[0].data[5] = 0;
            this.ProductcolumnChart.series[0].data[6] = 0;
            this.ProductcolumnChart.series[0].data[7] = 0;
            this.ProductcolumnChart.series[0].data[8] = 0;
            this.ProductcolumnChart.series[0].data[9] = 0;
            this.ProductcolumnChart.series[0].data[10] = 0;
            this.ProductcolumnChart.series[0].data[11] = 0;

            this.ProductPerformance[0]?(this.ProductcolumnChart.chartOptions.xaxis.categories[0] = this.ProductPerformance[0].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[0] = '';
            this.ProductPerformance[1]?(this.ProductcolumnChart.chartOptions.xaxis.categories[1] = this.ProductPerformance[1].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[1] = '';
            this.ProductPerformance[2]?(this.ProductcolumnChart.chartOptions.xaxis.categories[2] = this.ProductPerformance[2].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[2] = '';
            this.ProductPerformance[3]?(this.ProductcolumnChart.chartOptions.xaxis.categories[3] = this.ProductPerformance[3].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[3] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[4] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[5] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[6] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[7] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[8] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[9] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[10] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[11] = '';


              //User Line Chart            
            this.ProductPerformance[0]?(this.ProductLineChart.series[0].data[0] = parseInt(this.ProductPerformance[0].total_sales)):this.ProductLineChart.series[0].data[0] = 0;
            this.ProductPerformance[1]?(this.ProductLineChart.series[0].data[1] = parseInt(this.ProductPerformance[1].total_sales)):this.ProductLineChart.series[0].data[1] = 0;
            this.ProductPerformance[2]?(this.ProductLineChart.series[0].data[2] = parseInt(this.ProductPerformance[2].total_sales)):this.ProductLineChart.series[0].data[2] = 0;
            this.ProductPerformance[3]?(this.ProductLineChart.series[0].data[3] = parseInt(this.ProductPerformance[3].total_sales)):this.ProductLineChart.series[0].data[3] = 0;
            this.ProductLineChart.series[0].data[4] = 0;
            this.ProductLineChart.series[0].data[5] = 0;
            this.ProductLineChart.series[0].data[6] = 0;
            this.ProductLineChart.series[0].data[7] = 0;
            this.ProductLineChart.series[0].data[8] = 0;
            this.ProductLineChart.series[0].data[9] = 0;
            this.ProductLineChart.series[0].data[10] = 0;
            this.ProductLineChart.series[0].data[11] = 0;

            this.ProductPerformance[0]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[0].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[0] = '';
            this.ProductPerformance[1]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[1].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[1] = '';
            this.ProductPerformance[2]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[2].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[2] = '';
            this.ProductPerformance[3]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[3].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[3] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[4] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[5] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[6] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[7] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[8] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[9] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[10] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[11] = '';


            this.ProductPerformance[0]?(this.ProductdonutChart.chartOptions.labels[0] = this.ProductPerformance[0].dataLabel):this.ProductdonutChart.chartOptions.labels[0] = '';
            this.ProductPerformance[1]?(this.ProductdonutChart.chartOptions.labels[1] = this.ProductPerformance[1].dataLabel):this.ProductdonutChart.chartOptions.labels[1] = '';
            this.ProductPerformance[2]?(this.ProductdonutChart.chartOptions.labels[2] = this.ProductPerformance[2].dataLabel):this.ProductdonutChart.chartOptions.labels[2] = '';
            this.ProductPerformance[3]?(this.ProductdonutChart.chartOptions.labels[3] = this.ProductPerformance[3].dataLabel):this.ProductdonutChart.chartOptions.labels[3] = '';
            this.ProductdonutChart.chartOptions.labels[4] = '';
            this.ProductdonutChart.chartOptions.labels[5] = '';
            this.ProductdonutChart.chartOptions.labels[6] = '';
            this.ProductdonutChart.chartOptions.labels[7] = '';
            this.ProductdonutChart.chartOptions.labels[8] = '';
            this.ProductdonutChart.chartOptions.labels[9] = '';
            this.ProductdonutChart.chartOptions.labels[10] = '';
            this.ProductdonutChart.chartOptions.labels[11] = '';

          }else if(this.filterData.time == 'last8W'){
              //User Column Chart            
            this.ProductPerformance[0]?(this.ProductcolumnChart.series[0].data[0] = parseInt(this.ProductPerformance[0].total_sales)):this.ProductcolumnChart.series[0].data[0] = 0;
            this.ProductPerformance[1]?(this.ProductcolumnChart.series[0].data[1] = parseInt(this.ProductPerformance[1].total_sales)):this.ProductcolumnChart.series[0].data[1] = 0;
            this.ProductPerformance[2]?(this.ProductcolumnChart.series[0].data[2] = parseInt(this.ProductPerformance[2].total_sales)):this.ProductcolumnChart.series[0].data[2] = 0;
            this.ProductPerformance[3]?(this.ProductcolumnChart.series[0].data[3] = parseInt(this.ProductPerformance[3].total_sales)):this.ProductcolumnChart.series[0].data[3] = 0;
            this.ProductPerformance[4]?(this.ProductcolumnChart.series[0].data[4] = parseInt(this.ProductPerformance[4].total_sales)):this.ProductcolumnChart.series[0].data[4] = 0;
            this.ProductPerformance[5]?(this.ProductcolumnChart.series[0].data[5] = parseInt(this.ProductPerformance[5].total_sales)):this.ProductcolumnChart.series[0].data[5] = 0;
            this.ProductPerformance[6]?(this.ProductcolumnChart.series[0].data[6] = parseInt(this.ProductPerformance[6].total_sales)):this.ProductcolumnChart.series[0].data[6] = 0;
            this.ProductPerformance[7]?(this.ProductcolumnChart.series[0].data[7] = parseInt(this.ProductPerformance[7].total_sales)):this.ProductcolumnChart.series[0].data[7] = 0;
            this.ProductcolumnChart.series[0].data[8] = 0;
            this.ProductcolumnChart.series[0].data[9] = 0;
            this.ProductcolumnChart.series[0].data[10] = 0;
            this.ProductcolumnChart.series[0].data[11] = 0;

            this.ProductPerformance[0]?(this.ProductcolumnChart.chartOptions.xaxis.categories[0] = this.ProductPerformance[0].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[0] = '';
            this.ProductPerformance[1]?(this.ProductcolumnChart.chartOptions.xaxis.categories[1] = this.ProductPerformance[1].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[1] = '';
            this.ProductPerformance[2]?(this.ProductcolumnChart.chartOptions.xaxis.categories[2] = this.ProductPerformance[2].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[2] = '';
            this.ProductPerformance[3]?(this.ProductcolumnChart.chartOptions.xaxis.categories[3] = this.ProductPerformance[3].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[3] = '';
            this.ProductPerformance[4]?(this.ProductcolumnChart.chartOptions.xaxis.categories[4] = this.ProductPerformance[4].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[4] = '';
            this.ProductPerformance[5]?(this.ProductcolumnChart.chartOptions.xaxis.categories[5] = this.ProductPerformance[5].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[5] = '';
            this.ProductPerformance[6]?(this.ProductcolumnChart.chartOptions.xaxis.categories[6] = this.ProductPerformance[6].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[6] = '';
            this.ProductPerformance[7]?(this.ProductcolumnChart.chartOptions.xaxis.categories[7] = this.ProductPerformance[7].dataLabel):this.ProductcolumnChart.chartOptions.xaxis.categories[7] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[8] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[9] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[10] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[11] = '';


              //User Line Chart            
            this.ProductPerformance[0]?(this.ProductLineChart.series[0].data[0] = parseInt(this.ProductPerformance[0].total_sales)):this.ProductLineChart.series[0].data[0] = 0;
            this.ProductPerformance[1]?(this.ProductLineChart.series[0].data[1] = parseInt(this.ProductPerformance[1].total_sales)):this.ProductLineChart.series[0].data[1] = 0;
            this.ProductPerformance[2]?(this.ProductLineChart.series[0].data[2] = parseInt(this.ProductPerformance[2].total_sales)):this.ProductLineChart.series[0].data[2] = 0;
            this.ProductPerformance[3]?(this.ProductLineChart.series[0].data[3] = parseInt(this.ProductPerformance[3].total_sales)):this.ProductLineChart.series[0].data[3] = 0;
            this.ProductPerformance[4]?(this.ProductLineChart.series[0].data[4] = parseInt(this.ProductPerformance[4].total_sales)):this.ProductLineChart.series[0].data[4] = 0;
            this.ProductPerformance[5]?(this.ProductLineChart.series[0].data[5] = parseInt(this.ProductPerformance[5].total_sales)):this.ProductLineChart.series[0].data[5] = 0;
            this.ProductPerformance[6]?(this.ProductLineChart.series[0].data[6] = parseInt(this.ProductPerformance[6].total_sales)):this.ProductLineChart.series[0].data[6] = 0;
            this.ProductPerformance[7]?(this.ProductLineChart.series[0].data[7] = parseInt(this.ProductPerformance[7].total_sales)):this.ProductLineChart.series[0].data[7] = 0;
            this.ProductLineChart.series[0].data[8] = 0;
            this.ProductLineChart.series[0].data[9] = 0;
            this.ProductLineChart.series[0].data[10] = 0;
            this.ProductLineChart.series[0].data[11] = 0;

            this.ProductPerformance[0]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[0].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[0] = '';
            this.ProductPerformance[1]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[1].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[1] = '';
            this.ProductPerformance[2]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[2].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[2] = '';
            this.ProductPerformance[3]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[3].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[3] = '';
            this.ProductPerformance[4]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[4].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[4] = '';
            this.ProductPerformance[5]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[5].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[5] = '';
            this.ProductPerformance[6]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[6].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[6] = '';
            this.ProductPerformance[7]?(this.ProductLineChart.chartoptions.xaxis.categories[0] = this.ProductPerformance[7].dataLabel):this.ProductLineChart.chartoptions.xaxis.categories[7] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[8] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[9] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[10] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[11] = '';

            this.ProductPerformance[0]?(this.ProductdonutChart.chartOptions.labels[0] = this.ProductPerformance[0].dataLabel):this.ProductdonutChart.chartOptions.labels[0] = '';
            this.ProductPerformance[1]?(this.ProductdonutChart.chartOptions.labels[1] = this.ProductPerformance[1].dataLabel):this.ProductdonutChart.chartOptions.labels[1] = '';
            this.ProductPerformance[2]?(this.ProductdonutChart.chartOptions.labels[2] = this.ProductPerformance[2].dataLabel):this.ProductdonutChart.chartOptions.labels[2] = '';
            this.ProductPerformance[3]?(this.ProductdonutChart.chartOptions.labels[3] = this.ProductPerformance[3].dataLabel):this.ProductdonutChart.chartOptions.labels[3] = '';
            this.ProductPerformance[4]?(this.ProductdonutChart.chartOptions.labels[4] = this.ProductPerformance[4].dataLabel):this.ProductdonutChart.chartOptions.labels[4] = '';
            this.ProductPerformance[5]?(this.ProductdonutChart.chartOptions.labels[5] = this.ProductPerformance[5].dataLabel):this.ProductdonutChart.chartOptions.labels[5] = '';
            this.ProductPerformance[6]?(this.ProductdonutChart.chartOptions.labels[6] = this.ProductPerformance[6].dataLabel):this.ProductdonutChart.chartOptions.labels[6] = '';
            this.ProductPerformance[7]?(this.ProductdonutChart.chartOptions.labels[7] = this.ProductPerformance[7].dataLabel):this.ProductdonutChart.chartOptions.labels[7] = '';
            this.ProductdonutChart.chartOptions.labels[8] = '';
            this.ProductdonutChart.chartOptions.labels[9] = '';
            this.ProductdonutChart.chartOptions.labels[10] = '';
            this.ProductdonutChart.chartOptions.labels[11] = '';

          }else if(this.filterData.time == 'last3M'){
              //Product Column Chart            

            for (const item of this.ProductPerformance) {
              if (item.dataLabel === (new Date().getMonth() + 1)) {
                  this.ProductcolumnChart.series[0].data[0] = item.total_sales;
                  this.ProductLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth())) {
                  this.ProductcolumnChart.series[0].data[1] = item.total_sales;
                  this.ProductLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 1)) {
                  this.ProductcolumnChart.series[0].data[2] = item.total_sales;
                  this.ProductLineChart.series[0].data[2] = item.total_sales;
              }
            }            

            this.ProductcolumnChart.chartOptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.ProductcolumnChart.chartOptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.ProductcolumnChart.chartOptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.ProductcolumnChart.chartOptions.xaxis.categories[3] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[4] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[5] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[6] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[7] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[8] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[9] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[10] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[11] = '';

            this.ProductLineChart.chartoptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.ProductLineChart.chartoptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.ProductLineChart.chartoptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.ProductLineChart.chartoptions.xaxis.categories[3] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[4] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[5] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[6] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[7] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[8] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[9] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[10] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[11] = '';

            this.ProductdonutChart.chartOptions.labels[0] = this.months[new Date().getMonth() ];
            this.ProductdonutChart.chartOptions.labels[1] = this.months[new Date().getMonth() - 1];
            this.ProductdonutChart.chartOptions.labels[2] = this.months[new Date().getMonth() - 2];
            this.ProductdonutChart.chartOptions.labels[3] = '';
            this.ProductdonutChart.chartOptions.labels[4] = '';
            this.ProductdonutChart.chartOptions.labels[5] = '';
            this.ProductdonutChart.chartOptions.labels[6] = '';
            this.ProductdonutChart.chartOptions.labels[7] = '';
            this.ProductdonutChart.chartOptions.labels[8] = '';
            this.ProductdonutChart.chartOptions.labels[9] = '';
            this.ProductdonutChart.chartOptions.labels[10] = '';
            this.ProductdonutChart.chartOptions.labels[11] = '';
          }else if(this.filterData.time == 'last6M'){
              //Product Column Chart 
            for (const item of this.ProductPerformance) {
              if (item.dataLabel === (new Date().getMonth() + 1)) {
                  this.ProductcolumnChart.series[0].data[0] = item.total_sales;
                  this.ProductLineChart.series[0].data[0] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth())) {
                  this.ProductcolumnChart.series[0].data[1] = item.total_sales;
                  this.ProductLineChart.series[0].data[1] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 1)) {
                  this.ProductcolumnChart.series[0].data[2] = item.total_sales;
                  this.ProductLineChart.series[0].data[2] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 2)) {
                  this.ProductcolumnChart.series[0].data[3] = item.total_sales;
                  this.ProductLineChart.series[0].data[3] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 3)) {
                  this.ProductcolumnChart.series[0].data[4] = item.total_sales;
                  this.ProductLineChart.series[0].data[4] = item.total_sales;
              }else if (item.dataLabel === (new Date().getMonth() - 4)) {
                  this.ProductcolumnChart.series[0].data[5] = item.total_sales;
                  this.ProductLineChart.series[0].data[5] = item.total_sales;
              }
            } 

            this.ProductcolumnChart.chartOptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.ProductcolumnChart.chartOptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.ProductcolumnChart.chartOptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.ProductcolumnChart.chartOptions.xaxis.categories[3] = this.months[new Date().getMonth() - 3];
            this.ProductcolumnChart.chartOptions.xaxis.categories[4] = this.months[new Date().getMonth() - 4];
            this.ProductcolumnChart.chartOptions.xaxis.categories[5] = this.months[new Date().getMonth() - 5];
            this.ProductcolumnChart.chartOptions.xaxis.categories[6] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[7] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[8] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[9] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[10] = '';
            this.ProductcolumnChart.chartOptions.xaxis.categories[11] = '';

              //Product Line Chart            
            this.ProductLineChart.chartoptions.xaxis.categories[0] = this.months[new Date().getMonth()];
            this.ProductLineChart.chartoptions.xaxis.categories[1] = this.months[new Date().getMonth() - 1];
            this.ProductLineChart.chartoptions.xaxis.categories[2] = this.months[new Date().getMonth() - 2];
            this.ProductLineChart.chartoptions.xaxis.categories[3] = this.months[new Date().getMonth() - 3];
            this.ProductLineChart.chartoptions.xaxis.categories[4] = this.months[new Date().getMonth() - 4];
            this.ProductLineChart.chartoptions.xaxis.categories[5] = this.months[new Date().getMonth() - 5];
            this.ProductLineChart.chartoptions.xaxis.categories[6] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[7] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[8] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[9] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[10] = '';
            this.ProductLineChart.chartoptions.xaxis.categories[11] = '';

            this.ProductdonutChart.chartOptions.labels[0] = this.months[new Date().getMonth() ];
            this.ProductdonutChart.chartOptions.labels[1] = this.months[new Date().getMonth() - 1];
            this.ProductdonutChart.chartOptions.labels[2] = this.months[new Date().getMonth() - 2];
            this.ProductdonutChart.chartOptions.labels[3] = this.months[new Date().getMonth() - 3];
            this.ProductdonutChart.chartOptions.labels[4] = this.months[new Date().getMonth() - 4];
            this.ProductdonutChart.chartOptions.labels[5] = this.months[new Date().getMonth() - 5];
            this.ProductdonutChart.chartOptions.labels[6] = '';
            this.ProductdonutChart.chartOptions.labels[7] = '';
            this.ProductdonutChart.chartOptions.labels[8] = '';
            this.ProductdonutChart.chartOptions.labels[9] = '';
            this.ProductdonutChart.chartOptions.labels[10] = '';
            this.ProductdonutChart.chartOptions.labels[11] = '';
          }
          
          //User Donut Chart
          this.ProductdonutChart.series[0] = parseInt(this.ProductPerformance[0]?this.ProductPerformance[0].total_sales:0);
          this.ProductdonutChart.series[1] = parseInt(this.ProductPerformance[1]?this.ProductPerformance[1].total_sales:0);
          this.ProductdonutChart.series[2] = parseInt(this.ProductPerformance[2]?this.ProductPerformance[2].total_sales:0);
          this.ProductdonutChart.series[3] = parseInt(this.ProductPerformance[3]?this.ProductPerformance[3].total_sales:0);
          this.ProductdonutChart.series[4] = parseInt(this.ProductPerformance[4]?this.ProductPerformance[4].total_sales:0);
          this.ProductdonutChart.series[5] = parseInt(this.ProductPerformance[5]?this.ProductPerformance[5].total_sales:0);
          this.ProductdonutChart.series[6] = parseInt(this.ProductPerformance[6]?this.ProductPerformance[6].total_sales:0);
          this.ProductdonutChart.series[7] = parseInt(this.ProductPerformance[7]?this.ProductPerformance[7].total_sales:0);
          this.ProductdonutChart.series[8] = parseInt(this.ProductPerformance[8]?this.ProductPerformance[8].total_sales:0);
          this.ProductdonutChart.series[9] = parseInt(this.ProductPerformance[9]?this.ProductPerformance[9].total_sales:0);

        }

        setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
        }, 100);
      }
    },
  },

  created() {
    this.FetchGraph(this.filterData);
    this.FetchProducts();
  },
};
</script>
<style scoped>
.spinner-grow {
  width: 1000px;
  height: 0;
}
</style>

<template>
  <Layout>
    <PageHeader title="Product Performance" />
    
    <div>
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-end"> 
            <!-- <div class="col-md-3 mt-4" v-if="filterData.time != 'custom'"> 
              <router-link to="/tabular_ProductPerformance"><button class="btn btn-success mr-2"><i class="fa fa-list"></i> Tabular View</button></router-link>
            </div>           -->
            <div class="col-md-3">
              <label for="">Select Product</label>
              <model-list-select
                    :list="Products ? Products : []"
                    @input="ProductCheck(), setProductLabel()" v-model="filterData.product"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Product"
                >
                <option value="all">All Products</option>
              </model-list-select>
            </div>
            <div class="col-md-3">
              <label for="">Select Chart type</label>
              <select class="form-control" v-model="chartselect.data">
                <option value="all">All Charts</option>
                <option value="bar">Bar Chart</option>
                <option value="donut">Donut Chart</option>
                <option value="line">Line Chart</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="filterData.time"
                option-value="value"
                size="sm"
                @input="
                  ProductCheck();
                  setProductLabel();                  
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-if="filterData.product != 'all' && filterData.time == 'custom'" class="col-md-2">
              <date-picker
                v-model="filterData.dateRange"
                range
                append-to-body
                @change="ProductCheck"
                lang="en"
                confirm
              ></date-picker>
            </div>     
          </div>
        </div>
      </div>
      <!-- end row -->

      <div class="row" v-if="filterData.product == 'all' && chartselect.data == 'donut' || chartselect.data == 'all' && filterData.product == 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Product Sales Pie Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="donut"
                :series="donutChart.series"
                :options="donutChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="row" v-if="filterData.product == 'all' && chartselect.data == 'bar' || chartselect.data == 'all' && filterData.product == 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Product Sales Bar Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="columnChart.series"
                :options="columnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>        
        <div class="row" v-if="filterData.product == 'all' && chartselect.data == 'line' || chartselect.data == 'all' && filterData.product == 'all'">
        <template>
          <div class="card">
            <div class="card-body">
            
              <h4 class="card-title mb-4">Product Sales Line Chart Report {{ graphLabel }}</h4>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="LineChart.series"
                  :options="LineChart.chartoptions"
                ></apexchart>
            </div>
          </div>
        </template>
        </div>

        <div class="row" v-if="filterData.product != 'all' && chartselect.data == 'donut' || chartselect.data == 'all' && filterData.product != 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{productdata}}'s Sales Pie Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="donut"
                :series="ProductdonutChart.series"
                :options="ProductdonutChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="row" v-if="filterData.product != 'all' && chartselect.data == 'bar' || chartselect.data == 'all' && filterData.product != 'all'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{productdata}}'s Sale Bar Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="ProductcolumnChart.series"
                :options="ProductcolumnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        
        <div class="row" v-if="filterData.product != 'all' && chartselect.data == 'line' || chartselect.data == 'all' && filterData.product != 'all'">
        <template>
          <div class="card">
            <div class="card-body">
            
              <h4 class="card-title mb-4">{{productdata}}'s Sale Line Chart Report {{ graphLabel }}</h4>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="ProductLineChart.series"
                  :options="ProductLineChart.chartoptions"
                ></apexchart>
            </div>
          </div>
        </template>
        </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
